import type {MithraMaterializedApi} from "../../services/MithraMaterializedApi";
import type {BagStore} from "../../stores/BagStore";
import type ProfileStore from "../../stores/ProfileStore";
import {makeAutoObservable, reaction} from "mobx";
import type {
    OpportunityStatusEnum,
    PpvOpportunity,
    PpvOpportunityListFilter
} from "../../services/classes/OpportunityClasses";
import {PageResponseManager} from "../../stores/managers/PageResponseManager";
import {environment} from "../../env";
import {analyticsOpportunityEvent} from "../../services/analytics/AnalyticEvents";
import {getOpportunityStatusName} from "./utils/OpportunityStatusVisual";
import type AuthStore from "../../authentication/AuthStore";


declare type OpportunityPageManager = PageResponseManager<PpvOpportunityListFilter, PpvOpportunity, {
    d: PpvOpportunity,
    f: PpvOpportunityListFilter,
}>;


export class OpportunityStoreBis {
    opportunityRowToEdit: PpvOpportunity | undefined = undefined


    // noinspection JSUnusedLocalSymbols
    constructor(
        private api: MithraMaterializedApi,
        private bagStore: BagStore,
        private profile: ProfileStore,
        private authStore: AuthStore,
    ) {
        makeAutoObservable(this)
        this.opportunityPages = new PageResponseManager(
            this.profile.p.ppvTablePageSize ?? environment.defaultPpvTablePageSize,
            (page, f) => {
                f.page = page;
                f.page_size = this.opportunityPages.pageSize;
                return this.api.listPpvOpportunity(f)
                    .then(r => {
                        // Inject the type to ensure we can use typescript's dynamic type resolution
                        r.data.results = r.data.results.map(d => ({d, f: f})) as any
                        return r as any;
                    });
            },
            ({d}) => d
        );


        reaction(() => [
            this.bagId,
        ] as const, () => {
            this.loadData()
        })

    }


    get bagId(): number {
        return this.bagStore.bagId;
    }

    setOpportunityRowToEdit(row: PpvOpportunity) {
        this.opportunityRowToEdit = row;
    }

    changeStatus(row: PpvOpportunity, status: OpportunityStatusEnum) {
        console.log('Changing status to', status)
        this.setOpportunityRowToEdit(row);
        if (this.opportunityRowToEdit && this.opportunityRowToEdit.id) {
            analyticsOpportunityEvent({
                type: 'ppv',
                key: this.opportunityRowToEdit.ppv_group_key,
                status: getOpportunityStatusName(this.opportunityRowToEdit.status),
                expected_savings: this.opportunityRowToEdit.current_expected_savings,
                user: this.authStore.email,
            })
            this.api.updatePpvOpportunity(this.opportunityRowToEdit.id, {status: status})
                .then(() => this.loadData())
        }
    }

    loadData() {
        console.log('Loading data')
        if (this.bagId === 0) {
            this.opportunityPages.reset()
        } else {
            this.opportunityPages.reloadView();
        }
    }

    readonly opportunityPages: OpportunityPageManager;

    get isLoadingParts(): boolean {
        return this.opportunityPages.isLoading;
    }
}